/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import { Snackbar } from "@material-ui/core";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
// eslint-disable-next-line no-restricted-imports
import LinearProgress from "@material-ui/core/LinearProgress";
import axios from "axios";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useSubheader } from "../../../_metronic/layout";
import { checkAndReplace } from "../../helpers/Formatter";
import { SnackbarWrapper } from "../Snackbar/SnackbarWrapper";
import { useSchoolContext } from "./components/SchoolDataContext";
import { SchoolEditForm } from "./components/SchoolEditForm";


const initSchool = {
  school_information_id: 0,
  school_name: "",
  school_address: "",
  city: "",
  state: "",
  zip: "",
  country: "",
  primary_email: "",
  primary_phone: "",
  active_id: "1",
  branch_id: "",
};

export function SchoolEdit({
  history,
  match: {
    params: { id },
  },
}) {
  const current_branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );

  // Subheader
  const suhbeader = useSubheader();

  // School data
  const [schoolData, setSchoolData] = useState();
  const [title, setTitle] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [schoolValues, setSchoolValues] = useState();
  const btnRef = useRef();

  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState("");
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);

  // Set branch_id from current branch
  initSchool.branch_id = current_branch?.branch_id || "";

  const context = useSchoolContext();
  const userId = useSelector(
    (state) => state.auth.user && state.auth.user[0].user_id
  );

  const handleClose = () => {
    setSuccessSnackbarMessage("");
    setErrorSnackbarMessage("");
    setShowSnackbar(false);
  };

  useEffect(() => {
    const loadSnackbarSuccess = async () => {
      setShowSnackbar(true);
      setLoading(false);
    };
    successSnackbarMessage &&
      successSnackbarMessage != "" &&
      loadSnackbarSuccess();
  }, [successSnackbarMessage]);

  useEffect(() => {
    const loadSnackbarError = async () => {
      setShowSnackbar(true);
      setLoading(false);
    };
    errorSnackbarMessage && errorSnackbarMessage != "" && loadSnackbarError();
  }, [errorSnackbarMessage]);

  useEffect(() => {
    let _title = id ? "Edit School" : "New School";

    setTitle(_title);
    suhbeader.setTitle(_title);
  }, [id]);

  useEffect(() => {
    const getSchoolFields = async () => {
      setLoading(true);
      try {
        const res_school = await context.getSchoolById(id);

        setSchoolData(res_school);
        setLoading(false);
        return res_school; 
      } catch (error) {
        console.error("Error fetching school:", error);
        setErrorSnackbarMessage("Failed to load school data");
        setLoading(false);
      }
    };

    id && getSchoolFields();
  }, [id]);

  useEffect(() => {
    const newSchoolData = id ? schoolData : initSchool;
    setSchoolValues(newSchoolData);
  }, [schoolData, id]);

  const saveSchool = async (schoolValues) => {
    setLoading(true);

    // Sanitize input values
    schoolValues.school_name = checkAndReplace(schoolValues.school_name);
    schoolValues.school_address = checkAndReplace(schoolValues.school_address);
    schoolValues.city = checkAndReplace(schoolValues.city);
    schoolValues.state = checkAndReplace(schoolValues.state);
    schoolValues.zip = checkAndReplace(schoolValues.zip);
    schoolValues.country = checkAndReplace(schoolValues.country);
    schoolValues.primary_email = checkAndReplace(schoolValues.primary_email);
    schoolValues.primary_phone = checkAndReplace(schoolValues.primary_phone);

    try {
      if (!id) {
        // Create new school
        const result = await context.createSchool(schoolValues);

        if (result && result.school) {
          setSuccessSnackbarMessage("School created successfully");
          setTimeout(() => {
            history.push(`/school-information/school-list`);
          }, 1000);
        } else {
          setErrorSnackbarMessage("Failed to create school");
        }
      } else {
        // Update existing school
        const result = await context.updateSchool(id, schoolValues);

        if (result && result.school) {
          setSuccessSnackbarMessage("School updated successfully");
          setTimeout(() => {
            history.push(`/school-information/school-list`);
          }, 1000);
        } else {
          setErrorSnackbarMessage("Failed to update school");
        }
      }
    } catch (error) {
      console.error("Error saving school:", error);

      // Handle specific error messages from the API
      if (error.response && error.response.data && error.response.data.error) {
        setErrorSnackbarMessage(error.response.data.error);
      } else if (error.response && error.response.status === 409) {
        setErrorSnackbarMessage("School name already exists in this branch");
      } else {
        setErrorSnackbarMessage("Failed to save school");
      }
    }

    setLoading(false);
  };

  const saveSchoolClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    } else {
      saveSchool(null);
    }
  };

  const backToSchoolList = () => {
    history.push(`/school-information/school-list`);
  };

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <SnackbarWrapper
          onClose={handleClose}
          variant={successSnackbarMessage != "" ? "success" : "error"}
          message={
            successSnackbarMessage != ""
              ? successSnackbarMessage
              : errorSnackbarMessage
          }
        />
      </Snackbar>
      <Card>
        <CardHeader
          title={
            id
              ? schoolValues
                ? `School: ${schoolValues.school_name}`
                : "Loading School Data"
              : "New School"
          }
        >
          <CardHeaderToolbar>
            <button
              type="button"
              onClick={backToSchoolList}
              className="btn btn-light"
            >
              <i className="fa fa-arrow-left"></i>
              Back
            </button>
            {`  `}
            <button
              type="submit"
              className="btn btn-primary ml-2"
              onClick={saveSchoolClick}
              disabled={isLoading}
            >
              {id ? "Save" : "Add"}
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        {isLoading && <LinearProgress color="secondary" styles="width:100%" />}
        <CardBody>
          {/* No tabs needed - just basic info */}
          <div className="mt-3">
            {schoolValues && (
              <SchoolEditForm
                schoolValues={schoolValues}
                btnRef={btnRef}
                saveSchool={saveSchool}
                isLoading={isLoading}
                setLoading={setLoading}
                setSuccessSnackbarMessage={setSuccessSnackbarMessage}
                setErrorSnackbarMessage={setErrorSnackbarMessage}
              />
            )}
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
}
